import { VALID_EMAIL_REGEX } from './config';

function isValidEmail(string) {
    return VALID_EMAIL_REGEX.test(string);
}

export { isValidEmail };
